<script setup lang="ts">
import { ContainerProps } from "./Container.props"

defineProps<ContainerProps>()
</script>

<template>
  <div
    class="
      banner-product_page-support-container
      flex flex-col
      gap-6
      px-4
      pb-2
      pt-6
    "
  >
    <!-- First Card -->
    <BannerProductPageSupportCard v-if="infoCard1" v-bind="infoCard1" />

    <!-- Second Card -->
    <BannerProductPageSupportCard v-if="infoCard2" v-bind="infoCard2" />

    <!-- Third Card -->
    <BannerProductPageSupportCard v-if="infoCard3" v-bind="infoCard3" />
  </div>
</template>
